import script from "./LinkusCallButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkusCallButton.vue?vue&type=script&setup=true&lang=ts"

import "./LinkusCallButton.vue?vue&type=style&index=0&id=743416ad&scoped=true&lang=css"
import "./LinkusCallButton.vue?vue&type=style&index=1&id=743416ad&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-743416ad"]])

export default __exports__